import Vue from 'vue'

import {
  getMatchedComponentsInstances,
  getChildrenComponentInstancesUsingFetch,
  promisify,
  globalHandleError,
  sanitizeComponent
} from './utils'

import NuxtError from '../src/app/layouts/error.vue'

import '../node_modules/normalize.css/normalize.css'

import '../src/app/assets/styles/main.scss'

import '../node_modules/@sohohouse/design-system/assets/global.css'

import _65a88512 from '../src/app/layouts/account.vue'
import _6bb0db17 from '../src/app/layouts/application-form.vue'
import _77180f1e from '../src/app/layouts/blank.vue'
import _6f6c098b from '../src/app/layouts/default.vue'
import _24daa310 from '../src/app/layouts/introduction.vue'
import _172fea08 from '../src/app/layouts/jss-default.vue'
import _7d275100 from '../src/app/layouts/logout.vue'
import _f7662442 from '../src/app/layouts/public.vue'
import _18c6ac5d from '../src/app/layouts/room-booking.vue'
import _4fba1e1a from '../src/app/layouts/settings-nonmember.vue'
import _a59e1bce from '../src/app/layouts/settings.vue'
import _1a3b2659 from '../src/app/layouts/sso.vue'
import _ed45ec38 from '../src/app/layouts/static.vue'

const layouts = { "_account": sanitizeComponent(_65a88512),"_application-form": sanitizeComponent(_6bb0db17),"_blank": sanitizeComponent(_77180f1e),"_default": sanitizeComponent(_6f6c098b),"_introduction": sanitizeComponent(_24daa310),"_jss-default": sanitizeComponent(_172fea08),"_logout": sanitizeComponent(_7d275100),"_public": sanitizeComponent(_f7662442),"_room-booking": sanitizeComponent(_18c6ac5d),"_settings-nonmember": sanitizeComponent(_4fba1e1a),"_settings": sanitizeComponent(_a59e1bce),"_sso": sanitizeComponent(_1a3b2659),"_static": sanitizeComponent(_ed45ec38) }

export default {
  render (h, props) {
    if (this.nuxt.err && NuxtError) {
      const errorLayout = (NuxtError.options || NuxtError).layout
      if (errorLayout) {
        this.setLayout(
          typeof errorLayout === 'function'
            ? errorLayout.call(NuxtError, this.context)
            : errorLayout
        )
      }
    }

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

      isFetching() {
      return this.nbFetching > 0
    }
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }

      const promises = pages.map((page) => {
        const p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }
        if (page.$fetch) {
          p.push(page.$fetch())
        } else {
          // Get all component instance to call $fetch
          for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
            p.push(component.$fetch())
          }
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        globalHandleError(error)
        this.error(error)
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
}
